import { h } from 'preact';
import type { ComponentType } from 'preact';
import { useState } from 'preact/hooks';

// A page whose code lives in its own chunk. It renders nothing until the chunk
// arrives, then itself. `load()` fetches the chunk ahead of time: the client
// loads the current page's chunk before the first render, so the prerendered
// HTML never blinks out, and the SSR build loads every page before rendering.
export type LazyPage = ComponentType<any> & { load: () => Promise<void> };

export function lazyPage(importer: () => Promise<ComponentType<any>>): LazyPage {
  let Page: ComponentType<any> | null = null;
  let pending: Promise<void> | null = null;
  const load = () =>
    (pending ??= importer().then((c) => {
      Page = c;
    }));

  function Lazy(props: Record<string, unknown>) {
    const [, rerender] = useState(0);
    if (Page) return h(Page, props);
    load().then(() => rerender((n) => n + 1));
    return null;
  }
  return Object.assign(Lazy, { load });
}

// Route patterns here are plain paths or `:param` segments; a trailing slash is
// ignored, as wouter ignores it.
export function matchesPath(pattern: string, path: string): boolean {
  const split = (p: string) => p.replace(/\/+$/, '').split('/');
  const a = split(pattern);
  const b = split(path);
  return a.length === b.length && a.every((seg, i) => seg.startsWith(':') ? b[i] !== '' : seg === b[i]);
}
